import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
    selector: 'app-addrresses',
    templateUrl: './addrresses.component.html',
    styleUrls: ['./addrresses.component.scss']
})
export class AddrressesComponent implements OnInit {

    @Input() eCaseId: any;
    @Input() caseId: any;
    addressList: any;
    caseAdressId: any;
    closeResult: string;
    regionId: any;
    cityId: any;
    weatherTypeId: any;
    district: any;
    buildingNumber: any;
    latitude: any;
    longitude: any;
    locationDescription: any;
    street: any;
    citiesList: any[];
    regionsList: any[];
    weatherList: any;
    lenAdd: any;
    klm: any;
    cityName: any;
    weatherTypeName: any;
    regionName: any;
    geoCoder: google.maps.Geocoder;
    address: string;
    locationShow: any;

    constructor(public caseservice: CaseService, public lookupService: LookupService, public sharedService: SharedHttpService, private modalService: NgbModal) { }
    @Input() loadDataFP: Observable<any>;
    ngOnInit(): void {


        this.loadDataFP.subscribe((data) => {
            setTimeout(() => {

                this.weatherList = this.lookupService.getLockup('weathertype');
                let regions = this.lookupService.getLockup('regions');
                let datawithoutElryad = [];
                let ryadData = [];
                regions.map((el: any) => {
                    el.text == 'الرياض' ? ryadData.push(el) : datawithoutElryad.push(el);
                });
                this.regionsList = [...ryadData, ...datawithoutElryad];
                this.loadData();

                this.findMe();
            }, 100);

        });



    }
    loadData() {
        //this.eCaseId = "CfDJ8KB0lZg2A_ZPtaX6jGgpVPetSBLNyNAy7e_nLTY6TSVlSmJYURlSBuZ4WFUg811wEeYtJYNNMapuZH0tdPmUeQ1dMTxWbhDymDI3nqar6QxFAC5K8siajl5-t301PWCZrw";

        if (this.caseservice.case != null) {


            let url: any = `api/CaseAddress/GetAllCaseAddresses?eCaseId=${this.eCaseId}`
            this.sharedService.get(url).subscribe(result => {
                this.addressList = result;
                this.lenAdd = this.addressList.length;
            });
        }
    }

    DeleteAddress(caseAdressId: any, mymodal) {
        this.sharedService.openLarge(mymodal);
        this.caseAdressId = caseAdressId;

    }


    onDeleteAddress() {
        let url = 'api/CaseAddress/Delete'
        this.sharedService.delete(url, [this.caseAdressId]).subscribe(
            (response) => {
                this.modalService.dismissAll();
                this.sharedService.showSuccessKey("DeletedSuccessfully");
                this.loadData();
            },
            // (error) => {                              
            //   console.error('error')
            //   this.toastr.showError(this.sharedService.getTranslatedKey("Notsaved"), this.sharedService.getTranslatedKey("Success"));
            // }
        );
    }

    getRegion(e) {
        this.citiesList = [];
        this.cityId = undefined;
        if (e) {
            let cities = this.lookupService.getLockup('cities');
            cities.map((el: any) => {
                if (el.more == this.regionId) {
                    this.citiesList.push(el);
                }
            });
        }

    }
    CreateAddress(modal) {
        this.regionId = undefined;
        this.cityId = undefined;
        this.weatherTypeId = undefined;
        this.district = "";
        this.buildingNumber = "";
        this.street = "";
        this.locationDescription = "";
        this.longitude = undefined;
        this.latitude = undefined;
        this.klm="";
        this.sharedService.openXLarge(modal);


    }


    onCreateAddress() {
        let url = 'api/CaseAddress/Insert';
        let objectAdded = {
            regionId: this.regionId,
            cityId: this.cityId,
            weatherTypeId: this.weatherTypeId,
            district: this.district,
            buildingNumber: this.buildingNumber,
            street: this.street,
            locationDescription: this.locationDescription,
            longitude: (this.longitude!=null)?this.longitude.toString():null,
            latitude: (this.latitude!=null)? this.latitude.toString():null,
            caseId: this.caseId,
            eCaseId: this.eCaseId,
            klm: this.klm
        };

        this.sharedService.post(url, [objectAdded]).subscribe(
            (response) => {
                this.modalService.dismissAll();
                this.loadData();


                this.sharedService.showSuccessKey("SavedSuccessfully");

            },

        );
    }

    EditAddress(address, modal) {
        this.regionId = address.regionId;
        this.getRegion(address.regionId);
        this.cityId = address.cityId;
        this.cityName = address.cityName;
        this.regionName = address.regionName;
        this.weatherTypeName = address.weatherTypeName;
        this.district = address.district;
        this.buildingNumber = address.buildingNumber;
        this.street = address.street;
        this.locationDescription = address.locationDescription;
        this.longitude = address.longitude;
        this.latitude = address.latitude;
        this.weatherTypeId = address.weatherTypeId;
        this.caseId = address.caseId;
        this.caseAdressId = address.caseAdressId;
        this.klm = address.klm;
        this.sharedService.openLarge(modal);

    }
    ShowAddress(address, modal) {
        this.regionId = address.regionId;
        this.getRegion(address.regionId);
        this.cityId = address.cityId;
        this.cityName = address.cityName;
        this.regionName = address.regionName;
        this.weatherTypeName = address.weatherTypeName;
        this.district = address.district;
        this.buildingNumber = address.buildingNumber;
        this.street = address.street;
        this.locationDescription = address.locationDescription;
        this.longitude = (address.longitude != null) ? address.longitude.toString() : null;
        this.latitude =  (address.latitude != null) ? address.latitude.toString() : null;
        this.weatherTypeId = address.weatherTypeId;
        this.caseId = address.caseId;
        this.caseAdressId = address.caseAdressId;
        this.klm = address.klm;
        let location = new google.maps.LatLng(this.latitude,this.longitude);
        this.loc = location;
        console.log(this.latitude);
        this.center2 = { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude)   };
        this.getAddress(this.latitude, this.longitude);

        this.sharedService.openLarge(modal);

    }
 
    onEditAddress() {
        let url = 'api/CaseAddress/Update';
        let objectAdded = {
            caseAdressId: this.caseAdressId,
            regionId: this.regionId,
            cityId: this.cityId,
            weatherTypeId: this.weatherTypeId,
            district: this.district,
            buildingNumber: this.buildingNumber,
            street: this.street,
            locationDescription: this.locationDescription,
            longitude: this.longitude.toString(),
            latitude: this.latitude.toString(),
            caseId: this.caseId,
            klm: this.klm,
            eCaseId: this.eCaseId
        };

        this.sharedService.put(url, [objectAdded]).subscribe(
            (response) => {

                this.sharedService.showSuccessKey("EditSuccessfully");



                this.modalService.dismissAll();
                this.loadData();

            },

        );
    }
    numberOnly(event) {
        var inp = String.fromCharCode(event.keyCode);
        let pattern = /^\d+$/;
        if (pattern.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    allowDecimal(event) {
        var inp = String.fromCharCode(event.keyCode);
        let pattern = /^\d*\.?\d*$/;
        if (pattern.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }


    findMe() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.showPosition(position);
            });
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }
  
    showPosition(position) {
        console.log(position);
        console.log(position.coords)

        this.currentLat = position.coords.latitude;
        this.currentLong = position.coords.longitude;

        let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.center = { lat: position.coords.latitude, lng: position.coords.longitude };
        // this.map.panTo(location);
        //this.loc = location;
        if (!this.marker) {
            this.marker = new google.maps.Marker({
                position: location,
                map: this.map,
                title: 'Got you!'
            });
        }
        else {
            this.marker.setPosition(location);
        }
    }
    
   
    currentLat: any;
    currentLong: any;
    marker: any;
    map: any;
    center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };;
    center2:any = { lat: 24, lng: 12 };;
    showTrackingPosition(position) {
        console.log(`tracking postion:  ${position.coords.latitude} - ${position.coords.longitude}`);
        this.currentLat = position.coords.latitude;
        this.currentLong = position.coords.longitude;

        let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.center = { lat: position.coords.latitude, lng: position.coords.longitude };
        this.loc = location;
        // this.map.panTo(location);

        if (!this.marker) {
            this.marker = new google.maps.Marker({
                position: location,
                map: this.map,
                title: 'Got you!'
            });
        }
        else {
            this.marker.setPosition(location);
        }
    }
    markerOptions: google.maps.MarkerOptions = { draggable: false };
    markerPositions: google.maps.LatLngLiteral[] = [];
    loc: any;
    moving(map, $event) {
        // console.log($event);
        // console.log(map.getCenter());
        //console.log(map.getCenter().lat());
        //this.markerPositions.pop();
        //this.markerPositions.push({ lat: map.getCenter().lat(), lng: map.getCenter().lng() });
        this.latitude = map.getCenter().lat();
        this.longitude = map.getCenter().lng();
        //this.center = { lat: map.getCenter().lat(), lng: map.getCenter().lng() };
        let location = new google.maps.LatLng(map.getCenter().lat(), map.getCenter().lng());
        this.loc = location;
        //console.log($event);
        //console.log(this.loc.lng());
        this.getAddress(this.latitude, this.longitude);
    }
    getAddress(latitude, longitude) {
        this.geoCoder = new google.maps.Geocoder;
        this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    this.address = results[0].formatted_address;
                    console.log(results[0]);
                    var splitted = this.address.split(",");
                    console.log(results[0].address_components);
                    this.street = splitted[0];
                    this.district = splitted[1];
                } else {
                    console.log(status

                    );

                }
            } else {
                console.log("no address");

            }

        });

    }

    imageUrl = 'https://angular.io/assets/images/logos/angular/angular.svg';
    imageBounds: google.maps.LatLngBoundsLiteral = {
        east: 10,
        north: 10,
        south: -10,
        west: -10,
    };
}
